import Title from './Title';

export { default as BetaTitle } from './BetaTitle';

export default Title;
